// src/components/ProtectedRoute.js
// ──────────────────────────────────────────────────────────────────────────
// Gate for pages that require login. Redirects to /login (remembering where
// the visitor was headed). If Supabase isn't configured yet, it lets people
// through so the site still works during setup.
// ──────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading, ready } = useAuth();
  const location = useLocation();
  const [graceDone, setGraceDone] = React.useState(false);

  // Give the session a brief moment to load before deciding, so a slow
  // session read can't bounce a logged-in user on a hard refresh.
  React.useEffect(() => {
    const t = setTimeout(() => setGraceDone(true), 600);
    return () => clearTimeout(t);
  }, []);

  if (!ready) return children;                 // backend not set up yet
  if (loading || !graceDone) return null;      // still resolving the session
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
